import { render, staticRenderFns } from "./GooglePlayChannelDetail.vue?vue&type=template&id=a9d29ce8&scoped=true"
import script from "./GooglePlayChannelDetail.vue?vue&type=script&lang=js"
export * from "./GooglePlayChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./GooglePlayChannelDetail.vue?vue&type=style&index=0&id=a9d29ce8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d29ce8",
  null
  
)

export default component.exports